// extracted by mini-css-extract-plugin
module.exports = {"betslipButton":"betslipButton-4BY0H","innerFlexWrapper":"innerFlexWrapper-1odze","betButtonLabel":"betButtonLabel--YeHc","betslipButtonV2":"betslipButtonV2-Lqe8b"};